// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"b2b3684f","360":"c767c3dd","417":"549bbf6d","429":"b2b3684f","563":"c767c3dd","661":"c767c3dd","699":"c767c3dd","780":"c767c3dd","854":"d89c82fa"}[chunkId] + ".chunk.css";
};